import React, { useEffect } from "react";
import classes from "./checkout-form.module.scss";
import {
  validateUserDetails,
  validateShippingAddress,
} from "../../../utils/validators";

function ShippingForm(props) {
  useEffect(() => {
    if (props.profile && !Array.isArray(props.profile) && props.profile.email) {
      props.setUserDetails({
        first_name: props.profile.first_name || "",
        last_name: props.profile.last_name || "",
        email: props.profile.email || "",
        phone: props.profile.phone || "",
      });
      props.setShippingDetails({
        address_country: props.profile.country || "India",
        address_zipcode: props.profile.ship_pincode || "",
        address_state: props.profile.ship_state || "",
        address_city: props.profile.ship_city || "",
        address_address: props.profile.ship_address || "",
      });
    }
  }, [props.profile]);

  useEffect(() => {
    if (props.VOData.order) {
      if (props.VOData.order.user_details)
        props.setUserDetails({
          first_name:
            props.VOData.order.user_details.virtual_order_profile_first_name,
          last_name:
            props.VOData.order.user_details.virtual_order_profile_last_name,
          email: props.VOData.order.user_details.virtual_order_profile_email,
          phone: props.VOData.order.user_details.virtual_order_profile_phone,
        });
      if (props.VOData.order.shipping_address)
        props.setShippingDetails({
          address_country:
            props.VOData.order.shipping_address.virtual_order_address_country,
          address_zipcode:
            props.VOData.order.shipping_address.virtual_order_address_zipcode,
          address_state:
            props.VOData.order.shipping_address.virtual_order_address_state,
          address_city:
            props.VOData.order.shipping_address.virtual_order_address_city,
          address_address:
            props.VOData.order.shipping_address.virtual_order_address_address,
        });
    }
  }, [props.VOData]);

  // Update a specific field error when the user edits after validation
  const clearUserError = (field, value) => {
    if (!props.validationTrace.user[field] || !props.setValidationTrace) return;
    const errors = validateUserDetails({
      ...props.userDetails,
      [field]: value,
    });
    props.setValidationTrace((prev) => ({
      ...prev,
      user: { ...prev.user, [field]: errors[field] || false },
    }));
  };

  const clearShippingError = (field, value) => {
    if (
      !props.validationTrace.shipping_address[field] ||
      !props.setValidationTrace
    )
      return;

    const errors = validateShippingAddress({
      ...props.shippingDetails,
      [field]: value,
    });
    props.setValidationTrace((prev) => ({
      ...prev,
      shipping_address: {
        ...prev.shipping_address,
        [field]: errors[field] || false,
      },
    }));
  };

  if (!props.VOData.order) {
    return (
      <div className={classes.formGrid}>
        <div>
          <div className={classes.skeletonInput} />
        </div>
        <div>
          <div className={classes.skeletonInput} />
        </div>
        <div>
          <div className={classes.skeletonInput} />
        </div>
        <div>
          <div className={classes.skeletonInput} />
        </div>
        <div className={classes.fullWidth}>
          <div className={classes.skeletonInput} />
        </div>
        <div>
          <div className={classes.skeletonInput} />
        </div>
        <div>
          <div className={classes.skeletonInput} />
        </div>
        <div>
          <div className={classes.skeletonInput} />
        </div>
        <div>
          <div className={classes.skeletonInput} />
        </div>
      </div>
    );
  }

  return (
    <div className={classes.formGrid}>
      {/* User Details */}
      <div className={classes.form_group}>
        <input
          type="text"
          className={classes.formInput}
          placeholder="First Name*"
          value={props.userDetails.first_name}
          minLength={3}
          maxLength={50}
          onChange={(e) => {
            props.setUserDetails({
              ...props.userDetails,
              first_name: e.target.value,
            });
            clearUserError("first_name", e.target.value);
          }}
        />
        <div
          className={`${classes.errorText} ${
            props.validationTrace.user.first_name
              ? classes.errorVisible
              : classes.errorHidden
          }`}
        >
          {typeof props.validationTrace.user.first_name === "string"
            ? props.validationTrace.user.first_name
            : "Please enter your first name."}
        </div>
      </div>
      <div className={classes.form_group}>
        <input
          type="text"
          className={classes.formInput}
          placeholder="Last Name*"
          value={props.userDetails.last_name}
          minLength={1}
          maxLength={50}
          onChange={(e) => {
            props.setUserDetails({
              ...props.userDetails,
              last_name: e.target.value,
            });
            clearUserError("last_name", e.target.value);
          }}
        />
        <div
          className={`${classes.errorText} ${
            props.validationTrace.user.last_name
              ? classes.errorVisible
              : classes.errorHidden
          }`}
        >
          {typeof props.validationTrace.user.last_name === "string"
            ? props.validationTrace.user.last_name
            : "Please enter your last name."}
        </div>
      </div>
      <div className={classes.form_group}>
        <input
          type="email"
          className={classes.formInput}
          placeholder="Email Address*"
          value={props.userDetails.email}
          onChange={(e) => {
            props.setUserDetails({
              ...props.userDetails,
              email: e.target.value,
            });
            clearUserError("email", e.target.value);
          }}
        />
        <div
          className={`${classes.errorText} ${
            props.validationTrace.user.email
              ? classes.errorVisible
              : classes.errorHidden
          }`}
        >
          {typeof props.validationTrace.user.email === "string"
            ? props.validationTrace.user.email
            : "Please use a valid email address."}
        </div>
      </div>
      <div className={classes.form_group}>
        <input
          type="tel"
          className={classes.formInput}
          placeholder="Phone Number*"
          value={props.userDetails.phone}
          onChange={(e) => {
            props.setUserDetails({
              ...props.userDetails,
              phone: e.target.value,
            });
            clearUserError("phone", e.target.value);
          }}
        />
        <div
          className={`${classes.errorText} ${
            props.validationTrace.user.phone
              ? classes.errorVisible
              : classes.errorHidden
          }`}
        >
          {typeof props.validationTrace.user.phone === "string"
            ? props.validationTrace.user.phone
            : "Please use a valid phone number."}
        </div>
      </div>

      {/* Shipping Address */}
      <div className={classes.fullWidth}>
        <input
          type="text"
          className={classes.formInput}
          minLength={3}
          maxLength={150}
          placeholder="Address*"
          value={props.shippingDetails.address_address}
          onChange={(e) => {
            props.setShippingDetails({
              ...props.shippingDetails,
              address_address: e.target.value,
            });
            clearShippingError("address_address", e.target.value);
          }}
        />
        <div
          className={`${classes.errorText} ${
            props.validationTrace.shipping_address.address_address
              ? classes.errorVisible
              : classes.errorHidden
          }`}
        >
          {typeof props.validationTrace.shipping_address.address_address ===
          "string"
            ? props.validationTrace.shipping_address.address_address
            : "Please specify an address for shipping."}
        </div>
      </div>
      <div className={classes.form_group}>
        <input
          type="text"
          className={classes.formInput}
          placeholder="Pin Code*"
          value={props.shippingDetails.address_zipcode}
          onChange={(e) => {
            props.setShippingDetails({
              ...props.shippingDetails,
              address_zipcode: e.target.value,
            });
            clearShippingError("address_zipcode", e.target.value);
          }}
        />
        <div
          className={`${classes.errorText} ${
            props.validationTrace.shipping_address.address_zipcode
              ? classes.errorVisible
              : classes.errorHidden
          }`}
        >
          {typeof props.validationTrace.shipping_address.address_zipcode === "string"
            ? props.validationTrace.shipping_address.address_zipcode
            : "Please specify a valid pin code."}
        </div>
      </div>
      <div className={classes.form_group}>
        <input
          type="text"
          className={classes.formInput}
          placeholder="City*"
          value={props.shippingDetails.address_city}
          onChange={(e) => {
            props.setShippingDetails({
              ...props.shippingDetails,
              address_city: e.target.value,
            });
            clearShippingError("address_city", e.target.value);
          }}
        />
        <div
          className={`${classes.errorText} ${
            props.validationTrace.shipping_address.address_city
              ? classes.errorVisible
              : classes.errorHidden
          }`}
        >
          {typeof props.validationTrace.shipping_address.address_city === "string"
            ? props.validationTrace.shipping_address.address_city
            : "Please specify a valid city."}
        </div>
      </div>
      <div className={classes.form_group}>
        <input
          type="text"
          className={classes.formInput}
          placeholder="State*"
          value={props.shippingDetails.address_state}
          onChange={(e) => {
            props.setShippingDetails({
              ...props.shippingDetails,
              address_state: e.target.value,
            });
            clearShippingError("address_state", e.target.value);
          }}
        />
        <div
          className={`${classes.errorText} ${
            props.validationTrace.shipping_address.address_state
              ? classes.errorVisible
              : classes.errorHidden
          }`}
        >
          {typeof props.validationTrace.shipping_address.address_state === "string"
            ? props.validationTrace.shipping_address.address_state
            : "Please specify a valid state."}
        </div>
      </div>
      <div className={classes.form_group}>
        <input
          type="text"
          className={classes.formInput}
          placeholder="Country*"
          value={props.shippingDetails.address_country}
          onChange={(e) => {
            props.setShippingDetails({
              ...props.shippingDetails,
              address_country: e.target.value,
            });
            clearShippingError("address_country", e.target.value);
          }}
        />
        <div
          className={`${classes.errorText} ${
            props.validationTrace.shipping_address.address_country
              ? classes.errorVisible
              : classes.errorHidden
          }`}
        >
          {typeof props.validationTrace.shipping_address.address_country === "string"
            ? props.validationTrace.shipping_address.address_country
            : "Please specify a valid country."}
        </div>
      </div>
    </div>
  );
}

export default ShippingForm;
